
define('text!modules/targeting/video/templates/bin_group_header.html',[],function () { return '<div class="group-c">{{bin_group_name}}&nbsp;({{groupItems.length}})</div>\n';});

